import {
  ShopifyDisputeItemSchema,
  shopifyDisputeStatus,
} from "@redotech/redo-model/disputes/shopify-dispute";
import * as z from "zod/v4";

export const getShopifyDisputes = {
  name: "getShopifyDisputes" as const,
  input: z.object({
    statuses: z.array(z.enum(shopifyDisputeStatus)).optional(),
  }),
  output: z.object({ disputes: z.array(ShopifyDisputeItemSchema) }),
};
